import React, {FC} from 'react'
import {useLocation} from 'react-router-dom'
import {useAnalyticsPageTracker} from '~/util'

export const RouteLog: FC = ({children}) => {
    const {pathname} = useLocation()
    useAnalyticsPageTracker(pathname)
    return <>{children}</>
}
